import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { Plano } from "./plano.model";
import { apiName } from "./data.service";

@Injectable()
export class PlanoApiService {
    private includef: any = ["marca","categoria"];

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Plano, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Plano, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"titulo","include":this.includef};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetAllPopulate(done: any) {
        let filter: any = {"order":"titulo","include":this.includef};
        this._restService.onGetPostCustom(apiName + '/populado', filter, done);//retornar planos populados com marcas
    }

    onGetById(objectId: number, done: any) {
        let filter: any = {"include":this.includef};
        this._restService.onGetPostId(apiName, objectId, filter, done);
    }

    onGetApiUrl() {
        return apiName;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/planos/shared/plano-api.service.ts
 **/